/** Emoji padrão exibido na roleta para fatias e histórico tipo "sem prêmio". */
export const ROULETTE_NONE_EMOJI = '😞'

/** Texto legado gravado em payloads antigos (substituído visualmente por {@link ROULETTE_NONE_EMOJI}). */
export function isLegacyRouletteNoneLabel(label: string): boolean {
  return /^tente\s+novamente/i.test(label.trim())
}

/** Linha principal do histórico quando `prize_type === 'none'`. */
export function displayNonePrizeHistoryLabel(payload: { label?: string | null } | null | undefined): string {
  const raw = typeof payload?.label === 'string' ? payload.label.trim() : ''
  if (raw && !isLegacyRouletteNoneLabel(raw) && raw !== ROULETTE_NONE_EMOJI) return raw
  return ROULETTE_NONE_EMOJI
}
